import type {ListExpedientsSearch} from "../-types";

import {PageContainerSkeleton, TableSkeleton, ToolbarSkeleton} from "@project/components/feedback";

import {expedientsRouteApi} from "../-route-api";

export function ExpedientsPending() {
  const search = expedientsRouteApi.useSearch() as ListExpedientsSearch;
  const perPage = search.perPage ?? 20;

  return (
    <PageContainerSkeleton>
      <ToolbarSkeleton>
        <div className="flex w-full gap-3 @lg:w-auto">
          <div className="flex-1 @lg:flex-none">
            <ToolbarSkeleton.Input />
          </div>
          <div className="hidden @lg:inline-flex">
            <ToolbarSkeleton.Button />
          </div>
          <div className="flex @lg:hidden">
            <ToolbarSkeleton.Button className="w-10" />
          </div>
        </div>
      </ToolbarSkeleton>

      <TableSkeleton columns={7} rows={perPage} />
    </PageContainerSkeleton>
  );
}
